import api from '@/lib/axios'

export interface PageSEO {
    _id: string
    pagePath: string
    meta_title: string
    meta_description: string
    meta_keywords: string
    createdAt?: string
    updatedAt?: string
}

export const PageSEOService = {
    getAll: async () => {
        const response = await api.get<PageSEO[]>('/page-seo')
        return response.data
    },

    getByPath: async (path: string) => {
        const response = await api.get<PageSEO>(`/page-seo/by-path?path=${encodeURIComponent(path)}`)
        return response.data
    },

    upsert: async (data: { pagePath: string; meta_title: string; meta_description: string; meta_keywords: string }) => {
        const response = await api.put<{ message: string; record: PageSEO }>('/page-seo', data)
        return response.data
    },

    delete: async (id: string) => {
        const response = await api.delete<{ message: string }>(`/page-seo/${id}`)
        return response.data
    }
}
